import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import FilterContainer from "./FiltersContainer";
import ResultContainer from "./ResultsContainer";
import { initializeSettings, setTotalResults } from '../redux/settings/page-settings-slice';
import { initializeFiltersFromUrl } from '../redux/filter/filter-slice';
import { useGetSearchResultsQuery } from '../redux/api-slice';
import { setLoading, setSearchData, setError, clearSearchData } from '../redux/search-data/search-data-slice';
import Searchbar from './Searchbar'
import { LoadingSpinner } from '../common/loadingSpinner';
export default function App() {
    const dispatch = useAppDispatch();
    const { query, page, pageSize, searchActive } = useAppSelector((state) => state.pageSettings);
    const { types, tags, filterVersion } = useAppSelector((state) => state.filterState);

    const { data, isLoading, isFetching, error } = useGetSearchResultsQuery(
        {
            query,
            types: types.join(','),
            tags: tags.join(','),
            page,
            pageSize,
            filterVersion // Include filterVersion to force refresh when filters change
        },
        {
            refetchOnMountOrArgChange: true,
            skip: !searchActive || !query || query.trim() === ''
        }
    );

    useEffect(() => {
        dispatch(initializeSettings());
        dispatch(initializeFiltersFromUrl());
    }, []);

    useEffect(() => {
        if (isLoading || isFetching) {
            dispatch(setLoading(true));
        }
    }, [isLoading, isFetching]);

    useEffect(() => {
        if (data) {
            dispatch(setSearchData(data));
            dispatch(setTotalResults(data.totalCount || 0));
        }
    }, [data, error]);


    useEffect(() => {
        if (!searchActive || !query || query.trim() === '') {
            dispatch(clearSearchData());
            dispatch(setTotalResults(0));
        }
    }, [searchActive, query]);

    // Check if this is initial loading (no filterCategories yet) vs filtering existing results
    const { filterCategories } = useAppSelector((state) => state.searchData);
    const isInitialLoading = isLoading;
    const gridClass = !data || !data.results || data.results.length === 0 || (!filterCategories.contentTypes?.length && !filterCategories.tags?.length) ? 'grid-1-col' : 'grid-3-9';

    return (
        <div className="search-app">
            <Searchbar />
            {isInitialLoading ? <LoadingSpinner /> :
                <div className={`grid ${gridClass} space-top-xl search-app-container`}>
                    <FilterContainer />
                    <div>
                        <ResultContainer />
                    </div>
                </div>
            }
        </div >
    );
}

















